<template>
  <div class="Kontakt" id="back1">
    <div class="form-wrap container">
      <label style=" font-size: 18px;">KONTAKT OSS</label>
      <br>
      <label style=" font-size: 15px;">Vi svarer så fort vi kan</label>
      <br>
      <br>

      <div v-if="!submitted">
        <div class="form-group">
          <label for="Navn1">Ditt navn</label>
          <input
            style="border-width: 1px;border-color: black;height: 45px;"
            v-model="Navn1"
            v-bind:class="{'form-control':true}"
          >
        </div>

        <div class="form-group">
          <label for="email">E-post</label>
          <input
            style="border-width: 1px;border-color: black;height: 45px;"
            v-model="email"
            v-bind:class="{'form-control':true, 'is-invalid' : !validEmail(email) && emailBlured}"
            v-on:blur="emailBlured = true"
          >
          <div class="invalid-feedback">A valid email is required</div>
        </div>

        <div class="form-group">
          <label for="Telefon1">Telefonnummer</label>
          <input
            style="border-width: 1px;border-color: black;height: 45px;"
            v-model="Telefon1"
            v-bind:class="{'form-control':true}"
          >
        </div>

        <div class="form-group">
          <label for="Beskjed1">Melding</label>
          <textarea
            style="border-width: 1px;border-color: black;"
            :rows="6"
            :max-rows="6"
            v-model="Beskjed1"
            v-bind:class="{'form-control':true}"
          />
        </div>

        <div class="form-group">
          <a
            type="submit"
            href="#"
            v-on:click.stop.prevent="submit"
            class="btn btn-lg btn-success"
          >Send melding</a>
        </div>
      </div>
      <div v-else class="alert alert-success" role="alert">
        <h5>Thank you</h5>
        <p>Your validation was a success!</p>
      </div>
    </div>
    <!--end form-wrapper-->
  </div>
</template>

<script>
export default {
  computed: {},
  data() {
    return {
      color: "red",
      fontSize: "23px",
      Navn1: "",
      email: "",
      Telefon1: "",
      Beskjed1: "",
      emailBlured: false,
      valid: false,
      submitted: false
    };
  },
  methods: {
    validate: function() {
      this.emailBlured = true;
      if (this.validEmail(this.email)) {
        this.valid = true;
      }
    },
    validEmail: function(email) {
      var re = /(.+)@(.+){2,}\.(.+){2,}/;
      return re.test(email.toLowerCase());
    },
    submit: function() {
      this.validate();
      if (this.valid) {
        //THIS IS WHERE YOU SUBMIT DATA TO SERVER
        this.submitted = true;
      }
    } //end submit
  }
};
</script>

<style scoped>

.form-wrap {
 margin-top: 20px;
  background: rgb(208, 233, 212);
}
.input {
  width: 35px;
  border-width: 5px;
  border-color: black;
  height: 30px;
  font-size: 18px;
}

.alert {
  padding-top: 1.5rem;
}
.alert h5 {
  margin-bottom: 0rem;
}
</style>
